module.exports = __webpack_public_path__ + "media/images/favicons_staging/safari-pinned-tab-dccf91eec1c9486539493d838b8778dd.svg";